export default (loading: boolean) =>
  loading ? <></> : null;
